import {SkeletonBlock} from '@aboutyou/ui-components';
import React from 'react';

export const AddToBasketQuickViewLoading: React.FC<{className?: string}> = ({
  className,
}) => {
  return (
    <section className={className}>
      <SkeletonBlock $width="100%" $height="40px" disableSpaceBelow />
    </section>
  );
};
